var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7H1.5C0.9 7 0.5 7.4 0.5 8C0.5 8.6 0.9 9 1.5 9H20.5C21.1 9 21.5 8.6 21.5 8C21.5 7.4 21.1 7 20.5 7ZM12.5 14H9.5C8.9 14 8.5 14.4 8.5 15C8.5 15.6 8.9 16 9.5 16H12.5C13.1 16 13.5 15.6 13.5 15C13.5 14.4 13.1 14 12.5 14ZM20.5 14H17.5C16.9 14 16.5 14.4 16.5 15C16.5 15.6 16.9 16 17.5 16H20.5C21.1 16 21.5 15.6 21.5 15C21.5 14.4 21.1 14 20.5 14ZM9.5 2H12.5C13.1 2 13.5 1.6 13.5 1C13.5 0.4 13.1 0 12.5 0H9.5C8.9 0 8.5 0.4 8.5 1C8.5 1.6 8.9 2 9.5 2ZM4.5 14H1.5C0.9 14 0.5 14.4 0.5 15C0.5 15.6 0.9 16 1.5 16H4.5C5.1 16 5.5 15.6 5.5 15C5.5 14.4 5.1 14 4.5 14ZM1.5 2H4.5C5.1 2 5.5 1.6 5.5 1C5.5 0.4 5.1 0 4.5 0H1.5C0.9 0 0.5 0.4 0.5 1C0.5 1.6 0.9 2 1.5 2ZM17.5 2H20.5C21.1 2 21.5 1.6 21.5 1C21.5 0.4 21.1 0 20.5 0H17.5C16.9 0 16.5 0.4 16.5 1C16.5 1.6 16.9 2 17.5 2Z",
    fill: "#E67700"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/Divider.91664ddf06696cf020ae8d7e644ae865.svg";
export { ForwardRef as ReactComponent };